import { SelectorFactory } from '@colibrio/colibrio-reader-framework/colibrio-core-selector-base';
import { EpubCfiFragmentSelectorParser } from '@colibrio/colibrio-reader-framework/colibrio-core-selector-epubcfi';

export const epubCfiSelectorFactory = new SelectorFactory([new EpubCfiFragmentSelectorParser()]);
